export default __webpack_public_path__ + "static/media/graphic-1-tablet.9c11a904.png";